module.exports = __webpack_public_path__ + "static/media/play-button-no-active.02c4297d.svg";